import { Injectable, Inject, EventEmitter, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { ProfileService } from '../../modules/profile/services/profile.service';
import { SnackbarFactory } from './snackbar-factory';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  currentBaseTheme: BaseThemes = "nagykun";
  currentBaseThemeModel: ThemeDto;

  private _isDarkMode: boolean = false;

  public availableThemes: ThemeDto[] = [];

  constructor(
    private profileService: ProfileService,
    private snackBar: SnackbarFactory,
    private authService: AuthService,
  ) {

    this.profileService.getTheme().pipe(
      map(res => {
        this.availableThemes = res;
        let baseTheme = this.availableThemes.find(th => th.thmIsDefault == true);
        if (baseTheme) {
          this.currentBaseTheme = baseTheme.thmName;
          this.currentBaseThemeModel = baseTheme;
        }

        if (this.authService.userSelectedThemeId != null) {
          let userTheme = this.availableThemes.find(th => th.thmId == this.authService.userSelectedThemeId);
          this.currentBaseTheme = userTheme.thmName;
          this.currentBaseThemeModel = userTheme;
        }

        if (this.authService.userIsDarkTheme != null) {
          this._isDarkMode = this.authService.userIsDarkTheme;
        }
      }),
      catchError(err => {
        return of();
      })
    ).subscribe({
      next: (res) => {
        this.onChange();
      },
    })
  }

  onChange() {
    document.body.classList.forEach(bodyClass => {
      document.body.classList.remove(bodyClass)
    });
    document.body.classList.add(this.currentTheme);

    var favicon = document.querySelector("link[rel~='icon']");
    favicon['href'] = `assets/themes/${this.currentFavicon}`;
  }

  onThemeChanged(updateToken: boolean, newThemeId: number, darkModeValue: boolean = this.isDarkMode) {
    let newTheme = this.availableThemes.find(th => th.thmId == newThemeId);

    let updateLocally = () => {
      this.currentBaseTheme = newTheme.thmName;
      this.currentBaseThemeModel = newTheme;
      this._isDarkMode = darkModeValue;
      this.onChange();
    }

    if (updateToken) {
      this.profileService.updateDefaultTheme(newThemeId, darkModeValue).pipe(
        catchError(err => {
          this.snackBar.showButtonSnackbar(err);
          return of();
        })
      ).subscribe({
        next: (res) => {
          this.authService.getNewAccessToken().subscribe({
            error: err => console.error(err)
          });
          updateLocally();
        }
      })
    }
    else {
      updateLocally();
    }
  }

  public get currentTheme() {
    //return `${this.currentBaseTheme}-${this._isDarkMode ? "dark" : "light"}`;
    return `nagykun-${this._isDarkMode ? "dark" : "light"}`;
  }

  public get currentFavicon() {
    //return `${this.currentBaseTheme}_favicon.png`;
    return `nagykun_favicon.png`;
  }

  public get currentLogo() {
    //return `${this.currentBaseTheme}_logo_${this._isDarkMode ? "dark" : "light"}.png`;
    return `nagykun_logo_${this._isDarkMode ? "dark" : "light"}.png`;
  }

  public get isDarkMode() {
    return this._isDarkMode;
  }

  public set isDarkMode(val: boolean) {
    this._isDarkMode = val;
    this.onThemeChanged(true, this.currentBaseThemeModel.thmId, this._isDarkMode);
  }
}

export type BaseThemes =
  "nagykun"

export interface ThemeDto {
  thmId: number;
  thmName: BaseThemes;
  thmIsDefault: boolean;
}
